import { List, ListItemButton, ListItemText, Typography } from "@mui/material";

import { IInspectionListItem } from "./raio-x.types";

const fmt = (iso: string) => new Intl.DateTimeFormat("pt-BR", { timeZone: "America/Sao_Paulo", dateStyle: "short", timeStyle: "short" }).format(new Date(iso));

export function RaioXHistory({
  items,
  currentId,
  onSelect,
  isError,
}: {
  items: IInspectionListItem[];
  currentId: string | null;
  onSelect: (id: string) => void;
  isError?: boolean;
}) {
  // why: history.data vem undefined (?? []) quando a query falha; sem esta checagem, um erro real (não 403, esse já esconde o painel) parecia "nenhuma inspeção".
  if (isError) return <Typography variant="body2" color="text.secondary">Não foi possível carregar o histórico.</Typography>;
  if (items.length === 0) return <Typography variant="body2" color="text.secondary">Nenhuma inspeção ainda.</Typography>;
  return (
    <List dense>
      {items.map((i) => (
        <ListItemButton key={i.id} selected={i.id === currentId} onClick={() => onSelect(i.id)}>
          <ListItemText
            primary={fmt(i.startedAt)}
            secondary={`${i.summary.bySeverity.BLOCKER} bloqueiam · ${i.summary.bySeverity.MAJOR} importantes · ${i.summary.bySeverity.MINOR} menores · catálogo ${i.catalogVersion}`}
          />
        </ListItemButton>
      ))}
    </List>
  );
}
